import API from '../app.api';
import ApiResources from '../../helpers/APIResource';
import store from '../../helpers/Store';

const BASE_URL = process.env.REACT_APP_PORTAL_API;

export const getKpi = async (module = "federated") => {
    try {
        const res = await API.get(`/api/v1/${module}/report/kpi`);
        ApiResources.hydrateResource(res.data);
        return res.data;
    } catch (err) {
        console.log('Error trying to get KPI data from API: ', err);
        return null;
    }
};

export const getFinancialSummary = async (module = "federated") => {
    try {
        const res = await API.get(`/api/v1/${module}/report/financial-summary`);
        ApiResources.hydrateResource(res.data);
        return res.data;
    } catch (err) {
        console.log('Error trying to get Financial Summary data from API: ', err);
        return null;
    }
};

export const getReportSummary = async (module = "federated") => {
    try {
        const res = await API.get(`/api/v1/${module}/report/report-summary`);
        ApiResources.hydrateResource(res.data);
        return res.data;
    } catch (err) {
        console.log('Error trying to get Report data from API: ', err);
        return null;
    }
};

export const getGenReportsInfo = async (module = "federated") => {
    try {
        const reqReturn = await API.get(`/api/v1/${module}/report/report-summary`);
        return reqReturn.data
    }
    catch (error) {
        return null;
    }
};

export const getReportHashed = async (hash, module = "federated") => {
    const access_token = store.getState().session?.access_token;
    const url = `${BASE_URL}/api/v1/${module}/report/report-summary/file/${hash}?access_token=${access_token}`;
    
    return url;
};
  
export const getHashReport = async (cycle, reportCode, selectChapel, reportType, module = "federated") => {
    try {
        const reqReturn = await API.get(`/api/v1/${module}/report/report-summary/generate?BusinessCycle=${cycle}&ReportType=${reportType}&ReportCode=${reportCode}&Chapel=${selectChapel}`);
        return reqReturn.data
    }
    catch (error) {
        return null;
    }
};
